<template>
  <div id="app">
    <Menu/>
    <transition name="animate">
        <router-view/>
    </transition>
    <h6>Designed by Brittany Foster<br/>Developed by <a href="https://www.linkedin.com/in/steven-ray-simon" target="_blank">Steven Simon</a></h6>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'

export default {
  name: 'App',
  components: {
    Menu
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

*{
  margin: 0;
  padding: 0;
}

body{
  background-color: #0E0C0A;
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #C5B9A6;
}

h6{
  padding: 10px 20px 60px 20px;
  font-size: 1em;
  line-height: 28px;
  color: #C5B9A6;
  font-weight: 500;
}

h6 a{
  text-decoration: none;
  color: #D9B44A;
}

 h6 a:hover{
        filter: brightness(0.6);
        transition: 0.4s;
    }

 .animate-enter-active, .animate-leave-active{
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
  }

  .animate-enter-active{
    transition-delay: 0.5s;
  }

  .animate-enter, .animate-leave-to{
    opacity: 0;
  }

  .animate-enter{
    transform: translateX(-100px);
  }

  .animate-leave-to{
    transform: translateX(100px);
  }

  .animate-enter-to, .animate-leave{
    opacity: 1;
    transform: translateX(0px);
  }
</style>
